import { IconWrapper } from '../runtime';
export default IconWrapper('star-selected', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.04906 1.063C7.42652 0.256348 8.57368 0.256342 8.95113 1.063L10.7272 4.85862L14.9336 5.35024C15.8279 5.45476 16.1845 6.56257 15.5191 7.16912L12.4192 9.9949L13.2426 14.0797C13.4193 14.9564 12.4891 15.6386 11.706 15.2065L8.0001 13.1616L4.29416 15.2065C3.5111 15.6386 2.58086 14.9564 2.75759 14.0797L3.58096 9.9949L0.481122 7.16912C-0.184255 6.56257 0.17233 5.45476 1.0666 5.35024L5.273 4.85862L7.04906 1.063Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});